<template>
  <b-form-group
    label="Çalışan Personeller"
    label-for="workers"
  >
    <validation-provider
      #default="{ errors }"
      name="Çalışan Personeller"
      rules="required"
    >
      <v-select
        id="workers"
        v-model="dataItem.workers"
        :options="dataList"
        placeholder="Seçin"
        label="name"
        :reduce="item => item.id"
        multiple
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'SelectWorkers',
  components: {
    ValidationProvider,
    BFormGroup,
    vSelect,
  },
  computed: {
    dataList() {
      return this.$store.getters['workers/dataList']
    },
    dataItem() {
      return this.$store.getters['serviceWorks/dataItem']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('workers/getDataList')
    },
  },
}
</script>
